import React, { useContext } from 'react';
import { Container } from '@pwskills/rachnaui';
import Faqs from '@/components/common/Faqs';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';

const Faq = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { faq } = courseDetails?.courseMetaDetails || {};

  return (
    <div className="bg-white">
      {faq && faq?.length > 0 && (
        <Container className="py-8 medium:py-12 large:!py-14 !px-4 medium:!px-8 large:!px-20">
          <Faqs
            faqsList={faq}
            classes="flex justify-start large:!justify-center regular:!w-full !text-6 !leading-9  large:!text-8 large:!leading-10 "
            showViewAllButton={false}
            wrapperClass="[&>header]:!pb-[12px] [&>header]:medium:!pb-[32px] [&>header]:large:!pb-[58px]"
          />
        </Container>
      )}
    </div>
  );
};

export default Faq;
